import { Quote, Star } from "lucide-react";

const list = [
  {
    name: "Marina A.",
    where: "Cemitério São João Batista",
    text: "Em um momento tão difícil, o atendimento foi rápido, gentil e a coroa chegou exatamente como combinado. Recomendo de coração.",
    stars: 5,
  },
  {
    name: "Eduardo F.",
    where: "Capela do Caju",
    text: "Pedi pelo WhatsApp de madrugada e entregaram em 1h30. A faixa veio impecável. Obrigado pela seriedade.",
    stars: 5,
  },
  {
    name: "Família Lopes",
    where: "Niterói",
    text: "Fizemos a homenagem da nossa mãe com a Central de Coroas. Atenção em cada detalhe, qualidade das flores e pontualidade.",
    stars: 5,
  },
];

export const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 bg-[#2D4A3E] text-white relative overflow-hidden">
      <div className="absolute -top-40 -right-40 w-[480px] h-[480px] rounded-full bg-[#BFA573]/15 blur-3xl" />
      <div className="container-wide relative">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#BFA573]">Depoimentos · 5,0 no Google</span>
          <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-3">
            Famílias que confiaram em nosso atendimento
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {list.map((t) => (
            <figure
              key={t.name}
              className="bg-white/5 border border-white/10 rounded-2xl p-7 backdrop-blur-sm hover:border-[#BFA573]/40 transition-colors duration-500"
            >
              <div className="flex items-center justify-between">
                <Quote className="h-6 w-6 text-[#BFA573]" strokeWidth={1.5} />
                <div className="flex gap-0.5">
                  {Array.from({length: t.stars}).map((_, i) => (
                    <Star key={i} className="h-3.5 w-3.5 text-[#F5B400] fill-[#F5B400]" strokeWidth={0} />
                  ))}
                </div>
              </div>
              <blockquote className="mt-4 text-white/90 leading-relaxed text-sm">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-5 pt-5 border-t border-white/10">
                <p className="font-serif text-lg">{t.name}</p>
                <p className="text-xs text-white/60 mt-0.5">{t.where}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
